import React, { Component, useRef, useState } from "react";
import {
    DataGrid,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup as dxLookup
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button, Lookup } from "devextreme-react";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarFundamentoLegalDs } from "../../DataSources";

const FundamentoLegalBox = (props) => {

    const { onSelecionado, usadoComoPesquisa } = props;
    let _gridInstance = useRef();
    let _formInstance = useRef();

    const dadosFiltroPadrao = { sequencial: undefined, origem: "", classificacao: "", textoSingular: "", textoPlural: "" };

    const [filtroState, setFiltroState] = useState(dadosFiltroPadrao);

    /* Alterar depois*/
    const dataSource = criarFundamentoLegalDs();

    const onAtualizandoRow = (e) => {
        e.cancel = true;
        props.history.push("fundamento_legal/editar/" + e.data.id);
    }

    const filtrar = (e) => {
        let filtro = filtroState;

        let filtroCorrente = [];

        if (
            filtro.sequencial !== undefined &&
            filtro.sequencial !== "" &&
            filtro.sequencial !== null
        ) {
            filtroCorrente.push(["sequencial", "=", filtro.sequencial]);
        }
        if (filtro.origem !== undefined && filtro.origem !== "") {
            filtroCorrente.push(["origem", "contains", filtro.origem.trim()]);
        }
        if (filtro.classificacao !== undefined && filtro.classificacao !== "") {
            filtroCorrente.push(["classificacao", "contains", filtro.classificacao.trim()]);
        }
        if (filtro.textoSingular !== undefined && filtro.textoSingular.trim()) {
            filtroCorrente.push(["textoSingular", "=", filtro.textoSingular]);
        }
        if (filtro.textoPlural !== undefined && filtro.textoPlural.trim()) {
            filtroCorrente.push(["textoPlural", "=", filtro.textoPlural]);
        }

        if (_gridInstance && _gridInstance.instance) {
            _gridInstance.instance.filter(
                filtroCorrente.length > 0 ? filtroCorrente : null
            );
        }

    }

    const limparFiltro = () => {
        setFiltroState({ ...dadosFiltroPadrao });
        filtrar();

        if (_formInstance && _formInstance.instance) {
            _formInstance.instance.repaint();
        }

        console.log("limpar filtro");
    }

    const novaEntidade = () => {
        props.history.push("fundamento_legal/novo");
    }

    return (
        <React.Fragment>
            <div className={"content-block dx-card responsive-paddings"}>
                <form onSubmit={filtrar}>
                    <Form id="frmPesquisa" formData={filtroState} colCount={10}
                        ref={(e) => (_formInstance = e)}>
                        <SimpleItem
                            dataField="sequencial"
                            editorType={"dxNumberBox"}
                            colSpan={2}
                            editorOptions={{ step: 0, value: null }}
                        >
                            <Label text="Código" />
                        </SimpleItem>
                        <SimpleItem dataField="origem" colSpan={3}>
                            <Label text="Origem" />
                        </SimpleItem>
                        
                        <SimpleItem dataField="classificacao" colSpan={5}>
                            <Label text="Classificação" />
                        </SimpleItem>

                        <SimpleItem dataField="textoSingular" colSpan={10}>
                            <Label text="Texto Singular" />
                        </SimpleItem>

                        <SimpleItem dataField="textoPlural" colSpan={10}>
                            <Label text="Texto Plural" />
                        </SimpleItem>
                    </Form>
                    <br />
                    <div style={{ marginTop: "10px" }}>
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={120}
                                text="Filtrar"
                                type="success"
                                onClick={filtrar}
                            />
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "10px" }}>
                            <Button text="Limpar Filtro" onClick={limparFiltro} />
                        </div>
                    </div>
                </form>
                <br /> <br />
                <PaginaToolbar
                    titulo="Fundamentos Legais"
                    novoCb={novaEntidade}
                >
                    <DataGrid
                        ref={(grid) => (_gridInstance = grid)}
                        dataSource={dataSource}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        columnAutoWidth={false}
                        focusedRowEnabled={true}
                        wordWrapEnabled={window.innerWidth < 800}
                        filterSyncEnabled={true}
                        onEditingStart={onAtualizandoRow}
                    >
                        <Editing
                            allowDeleting={!usadoComoPesquisa}
                            allowUpdating={!usadoComoPesquisa}
                            useIcons={true}
                            visible={!usadoComoPesquisa}
                        />

                        <Column
                            type="buttons"
                            fixed={true}
                            fixedPosition={"left"}
                            buttons={[
                                "edit",
                                "delete",
                                {
                                    hint: "Selecionar",
                                    icon: "repeat",
                                    visible: usadoComoPesquisa != undefined,
                                    onClick: onSelecionado,
                                },

                            ]}
                        />
                        <Column
                            dataField={"sequencial"}
                            visibleIndex={1}
                            allowEditing={false}
                            caption={"#"}
                            width={80}
                        />

                        <Column
                            dataField={"prefeituraId"}
                            caption={"Prefeitura"}
                            visible={false}
                        >
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column
                            dataField={"id"}
                            caption={"ID"}
                            visible={false}
                        >
                            <FormItem visible={false}></FormItem>
                        </Column>

                        <Column dataField={"origem"} caption={"Origem"} width={100}/>
                        <Column dataField={"nomeOficialTributo"} caption={"Tributo"} width={150} />
                        <Column dataField={"classificacao"} caption={"Classificação"} allowSorting={false} width={150} />
                        <Column dataField={"textoSingular"} caption={"Texto Singular"} />
                        <Column dataField={"textoPlural"} caption={"Texto Plural"} />
                        
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

                        <Pager
                            showInfo={true}
                            showNavigationButtons={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        </React.Fragment>
    );

}

export default FundamentoLegalBox;

